module.exports = __webpack_public_path__ + "static/media/how-it-works-a-few-steps-01.c544fb3c.jpg";